



































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import Spinner from "vue-spinner-component/src/Spinner.vue";
import { Token } from "../utils/Token";

@Component({
  components: {
    Spinner,
  },
})
export default class DeleteModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() user!: any;

  private errorModalFlag = false;
  private errorText = "";
  private errorTitle = "Error";

  private buttonsDisabled = false;
  private loading = true;

  private spinnerStatus = false;

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeDeleteModal", value);
  }

  created() {
    EventBus.$off('closeErrorModal')
    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
      EventBus.$emit("closeDeleteModal", value);
    });
  }


  private async deleteUser() {
    console.log("user to be deleted:", this.user);
    this.buttonsDisabled = true;
    this.spinnerStatus = true;
    this.errorText = "";

    const token = await Token.getTokenWithExpiry("token");
    const id = this.user.accountId;

    //DELETE API CALL
    axios({
      method: "delete",
      url: `${process.env.VUE_APP_BASE_URL}/account/${id}`,
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("successful delete API response:", response);
          console.log("with code:", response.data.code);

          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          if (response.data.code == 200) {
            //success
            this.closeEditAccountModal();
          } else if (response.data.code == 409) {
            //fail
            console.log("bad response code");
            this.errorText = "Unable to delete user.";
            this.errorModalFlag = true;
          }
        }
      })
      .catch((err) => {
        console.log("failed API call:", err);
        this.buttonsDisabled = false;
        this.spinnerStatus = false;
        this.errorText = "There was an error in deleting the user.";
        this.errorModalFlag = true;
      });
  }

  private closeEditAccountModal() {
    const snackbarData = {
      text: "User has been deleted",
      color: "danger",
    };
    EventBus.$emit("closeEditAccountModal", false);
    EventBus.$emit("closeEditDeviceModal", false);
    EventBus.$emit("refreshListing");
    EventBus.$emit("showSnackbar", snackbarData);
  }
}
